import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db, functions } from "../../config/firebase.config";
import { httpsCallable } from "firebase/functions";

export const setAppLiveService = async (isLive) => {
  const setAppLiveFn = httpsCallable(functions, "setAppLive");
  const response = await setAppLiveFn({ isLive });
  return response?.data;
};

export const subscribeToWaitlistCollection = (onData, onError) => {
  const waitlistRef = collection(db, "waitlist");
  const q = query(waitlistRef, orderBy("createdAt", "desc"));

  return onSnapshot(
    q,
    (snapshot) => {
      const emails = [];
      snapshot.forEach((doc) => {
        emails.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      onData(emails);
    },
    (error) => {
      onError(error);
    },
  );
};
